import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// signed: +$6,780 / -$96
export const money = (value) =>
  value == null
    ? "-"
    : `${value < 0 ? "-" : value > 0 ? "+" : ""}$${Math.abs(value).toLocaleString(
        "en-US",
        { maximumFractionDigits: 0 },
      )}`;

export const percent = (value) =>
  value == null ? "-" : `${value > 0 ? "+" : ""}${Number(value).toFixed(2)}%`;

export const ago = (date, now, empty = "-") => {
  if (!date) return empty;
  const seconds = Math.max(0, Math.round((now - new Date(date)) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m ago`;
  return dayjs(date).format("DD/MM HH:mm");
};

// "META 612.5C 06/11" for options, the symbol for stocks
export const tradeLabel = (trade) =>
  trade.option
    ? `${trade.symbol} ${trade.option.strike}${trade.option.right} ${dayjs
        .utc(trade.option.expiration)
        .format("DD/MM")}`
    : trade.symbol;

// a Mini App request's error text (Mini App endpoints: message; bot commands: error)
export const errorText = (err, fallback = "Something went wrong") =>
  err?.response?.data?.message || err?.response?.data?.error || fallback;
